import { combineReducers } from "@reduxjs/toolkit";
import imageUploadSlicer from "../features/imageUpload/imageUpload.slicer";

const rootReducer = combineReducers({
  imageUpload: imageUploadSlicer,
});

export default rootReducer;
